import {BaseFormModel} from '../base-form-model';
import {Person} from '../person';
import {Timecard} from '../timecard';

export class CashSessionEmployee extends BaseFormModel<CashSessionEmployee> {
    id: number;
    orgId: number;
    parentId: number;
    person: Person;
    hours: number;
    payrollTips: number;
    cashTips: number;
    total: number;
    manualHours: boolean;
    timecard: Timecard;

    percent: number;
    expected: number;
}
